<div class="ngtw-bar-line-chart fw fh" [style.opacity]="!isLoading ? '1' : '0.3'">
    <div class="loader" [hidden]="!isLoading">
        <div>{{message}}</div>
    </div>
    <div class="header">
        <h4 class="no-ellipses d-flex" title="Delivered Quantity (PC) vs Cost %">Delivered Quantity ({{unit}}) vs Cost %
            &nbsp;
            <div [popover]="popTemplate" triggers="mouseenter:mouseleave" container="body" placement="bottom">

                <img src="../../../assets/images/icn-info.svg" alt="">
            </div>
        </h4>
        <div class="full-screen" [hidden]="isLoading"  (click)='showComboGraphInPopup()'
            (keydown.enter)='showComboGraphInPopup()' (keydown.space)='showComboGraphInPopup()'></div>
    </div>
    <div class="chart-area fw fh" width="100%" [class.hide-graph]="isLoading"></div>
</div>
<ng-template #popTemplate>
    <div class="mb-15">Daily/Monthly trend of Delivered Quantity against Cost % at the Line level</div>

    <div class="tooltip-formula">
        <div class="tooltip-left">
            Cost % =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                total waste cost generated on day/month

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                total waste cost of the line for the selected period
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>